export default __webpack_public_path__ + "static/media/9 Mobility Flows.1d46dec7.png";